import React, { useRef } from "react";
import useValidation from "app/common/custom-hooks/useValidation";
import SpinnerButton from "app/common/components/SpinnerButton";
import FormInput from "app/common/components/FormInput";
import { update } from "app/common/util/Helpers";
import { useDispatch } from "react-redux";
import { forgotPassword } from "app/redux/auth/authHandler";
import useActionListener from "app/common/custom-hooks/useActionListener";

const Step1 = ({setStepsData, isLoading}) => {

    const formRef = useRef();
    const dispatch = useDispatch();
    const {validation, data: {email}} = useValidation(formRef);

    // Form Submission process
    const handleSubmit = _ => {
        update(setStepsData, {email});
        dispatch(forgotPassword(email));
    }

    useActionListener("recoveryOTPSent", _ => {
        update(setStepsData, {step: 2});
    })

    return  <div>
                <form onSubmit={handleSubmit} ref={formRef}>
                    <h2
                        className="text-3xl md:text-[2.5rem] md:leading-[3rem] text-black-1 font-semibold pb-2 dark:text-white "
                    >
                        Making commerce as simple as a chat
                    </h2>
                    <p
                        className="pb-12 text-grey-7"
                    >
                        Reset your password
                    </p>
                    <div className="">
                        <FormInput
                            label="Email:"
                            type='email' 
                            placeholder="example@mail.com" 
                            required 
                            name="email"
                            validation={validation}
                            invalidMessage="Enter a valid email address"
                        />
                        <div className="mt-9 mb-2">
                            <SpinnerButton 
                                type="submit" 
                                disabled={!validation.allValid} 
                                className="w-full btn-primary btn-md" 
                                isLoading={isLoading}
                                text="Send reset code"
                            />
                        </div>
                        {/* <div
                            className="py-8"
                        >
                            <hr />
                            <p className="text-center -mt-2.5">
                                <span
                                    className="inline-block px-5 bg-white"
                                >
                                    or
                                </span>
                            </p>
                        </div>
                        <div className="space-y-5">
                            <button
                                className="w-full btn-outline btn-md font-medium"
                                type="button"
                            >
                                <img
                                    src="/assets/media/image/google.png" alt="G" className="w-4 mr-2 -mt-1 inline"
                                /> Sign in with Google
                            </button>
                        </div> */}
                    </div>
                </form>
            </div>
}

export default Step1;